import { StyledContainer } from './styled-components'
import DistributorCard from '@/containers/SubscriptionFormPageNew/Components/Distributor/DistributorCard'
import useDistributor from '@/containers/SubscriptionFormPageNew/Components/Distributor/useDistributor'
import ModuleToggle from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleToggle'
import ModuleHeading from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeading'
import IconLocationCompany from '@/shared/icons/NewDesign/IconLocationCompany'
import useModuleCollapse from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/useModuleCollapse'
import ModuleHeader from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeader'
import { ModuleContent } from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/styled-components'

const DistributorContent = () => {
  const { t, eldElectricity, eldGas, eldWater } = useDistributor()
  const { expanded, toggle } = useModuleCollapse('distributor')
  return (
    <StyledContainer>
      <ModuleHeader clickable onClick={toggle}>
        <ModuleHeading icon={IconLocationCompany} moduleKey='distributor'>
          {t('subscriptionForm:distributor.title')}
        </ModuleHeading>
        <ModuleToggle expanded={expanded} onToggle={toggle} moduleKey='distributor' />
      </ModuleHeader>

      <ModuleContent hidden={!expanded}>
        <DistributorCard typeKey='common:energy_elec_long' data={eldElectricity} hidden={!eldElectricity.name} />

        <DistributorCard typeKey='common:energy_gas' data={eldGas} hidden={!eldGas.name} />

        <DistributorCard typeKey='common:water_text' data={eldWater} hidden={!eldWater.name} />
      </ModuleContent>
    </StyledContainer>
  )
}

export default DistributorContent
